module.exports = __webpack_public_path__ + "img/wenliyundongLeft.cc246704.gif";